module.exports = "<div class=q-pad-all-xl> <div> <p class=q-marg-bottom-md><span class=q-boldest>Notes Created:</span> (By {%- optional.css %} {%- optional.date %})</p> <div class=q-marg-top-md> <div class=\"pretty-well pw-border-rad q-text-left pw-pad-md\">{%- optional.notes %}</div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/cssReadNotesModalBody.html
// module id = 1358
// module chunks = 1